"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketRxMessage = exports.SocketTxMessage = exports.SocketRxMessageData = void 0;
class SocketRxMessageData {
    constructor(raw, { cacheUuid = null, online = true } = {
        cacheUuid: null,
        online: true
    }) {
        this.cacheUuid = cacheUuid;
        this.online = online;
        this.time = new Date();
        this.data = this._validate(raw);
        this._raw = raw;
    }
    get fromCache() {
        return !!this.cacheUuid;
    }
    ;
    // Raw JSON string
    get raw() {
        return this._raw || '{}';
    }
    set raw(value) {
        this.data = this._validate(value);
        this._raw = value;
        this.time = new Date();
    }
    // Tries to find the `messageType` attribute
    get messageType() {
        return this.data[SocketRxMessageData.keyHeaders][SocketRxMessageData.keyMessageType];
    }
    get body() {
        return this.data[SocketRxMessageData.keyBody];
    }
    _validate(content) {
        const data = JSON.parse(content);
        if (!data[SocketRxMessageData.keyHeaders] || !data[SocketRxMessageData.keyHeaders][SocketRxMessageData.keyMessageType]) {
            throw new Error('headers -> messageType is not defined in message: ' + content);
        }
        if (typeof data[SocketRxMessageData.keyBody] !== 'object') {
            throw new Error('body is not an object, but ' + typeof data[SocketRxMessageData.keyBody]);
        }
        return data;
    }
}
exports.SocketRxMessageData = SocketRxMessageData;
SocketRxMessageData.keyHeaders = 'headers';
SocketRxMessageData.keyBody = 'body';
SocketRxMessageData.keyMessageType = 'messageType';
class SocketTxMessage {
    constructor(messageType, authRequired = true) {
        this.messageType = messageType;
        this.authRequired = authRequired;
        this.cacheMs = null;
    }
    get data() {
        return this.proto.toJSON();
    }
}
exports.SocketTxMessage = SocketTxMessage;
class SocketRxMessage {
    constructor(messageType, message) {
        this.message = message;
        this.messageType = messageType;
    }
}
exports.SocketRxMessage = SocketRxMessage;
